(() => {
  if (window.ikaMenuInstalled) return;
  window.ikaMenuInstalled = true;
  const mobile = window.matchMedia('(max-width: 650px)');
  const headers = () => [...document.querySelectorAll('[data-ika-menu]')];
  const toggleFor = header => header.querySelector('.ika-menu-toggle');
  const close = (header, restoreFocus = false) => {
    const toggle = toggleFor(header);
    const active = document.activeElement;
    const openDetails = [...header.querySelectorAll('details[open]')];
    const activeDetails = openDetails.find(d => d.contains(active));
    const mobileWasOpen = toggle.getAttribute('aria-expanded') === 'true';
    openDetails.forEach(d => { d.open = false; });
    header.classList.remove('ika-menu-open');
    toggle.setAttribute('aria-expanded', 'false');
    if (restoreFocus) {
      if (mobile.matches && mobileWasOpen) toggle.focus();
      else activeDetails?.querySelector('summary')?.focus();
    }
  };
  const initialize = () => {
    headers().forEach(header => {
      if (header.classList.contains('ika-menu-ready')) return;
      header.classList.add('ika-menu-ready');
      toggleFor(header).hidden = false;
    });
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const target = event.target;
    const header = target.closest('[data-ika-menu]');
    headers().forEach(h => { if (h !== header) close(h); });
    if (!header) return;
    const toggle = target.closest('.ika-menu-toggle');
    if (toggle) {
      const opening = toggle.getAttribute('aria-expanded') !== 'true';
      close(header);
      header.classList.toggle('ika-menu-open', opening);
      toggle.setAttribute('aria-expanded', String(opening));
    } else if (target.closest('a')) {
      close(header);
    } else {
      const summary = target.closest('summary');
      if (summary) header.querySelectorAll('details[open]').forEach(d => {
        if (d !== summary.parentElement && !d.contains(summary)) d.open = false;
      });
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    headers().forEach(header => {
      if (header.querySelector('details[open]') || header.classList.contains('ika-menu-open')) {
        close(header, header.contains(document.activeElement));
        event.preventDefault();
      }
    });
  });
  document.addEventListener('focusin', event => {
    headers().forEach(header => { if (!header.contains(event.target)) close(header); });
  });
  document.addEventListener('shopify:section:load', initialize);
  mobile.addEventListener('change', () => headers().forEach(h => close(h, h.contains(document.activeElement))));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();
